import { useTransitTiming } from './useTransitTiming';
import { validTransitTiming } from '../utils/transitOverlay';
import { chartCalculationHeaders } from '../utils/chartCalculationTransport';
import React from 'react';
import axios from 'axios';

import { STUDIO_API_BASE_URL as API_BASE_URL } from '../api/studioClient';

export const useCurrentTransitOverlay = (chartData: any, enabled: boolean, timing?: { date?: string; time?: string }) => {
  const transitTiming = useTransitTiming(chartData);
  const selectedTiming = timing || transitTiming.timing;
  const [transitChart, setTransitChart] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!enabled) {
      setTransitChart(null);
      setError(null);
      setLoading(false);
      return;
    }

    const place = chartData?.birthDetails?.placeOfBirth || {};
    const city = place.city || place.name || 'Birthplace';
    const latitude = Number(place.latitude);
    const longitude = Number(place.longitude);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      setTransitChart(null);
      setError('Birthplace coordinates are missing.');
      setLoading(false);
      return;
    }

    if (!selectedTiming.date || !selectedTiming.time || !validTransitTiming({ date: selectedTiming.date, time: selectedTiming.time })) {
      setTransitChart(null); setLoading(false); setError('Choose a valid transit date and time.'); return;
    }
    let cancelled = false;

    const loadTransit = async () => {
      try {
        setTransitChart(null);
        setLoading(true);
        setError(null);
        const response = await axios.post(`${API_BASE_URL}/charts/transit`, {
          city,
          latitude,
          longitude,
          timezoneOffset: transitTiming.timezoneOffset,
          ayanamshaMode: chartData?.calculationData?.ayanamshaMode || chartData?.ayanamshaMode || 'LAHIRI',
          ...(selectedTiming.date && selectedTiming.time ? { date: selectedTiming.date, time: selectedTiming.time } : {}),
        }, { headers: chartCalculationHeaders(chartData) });

        if (!cancelled) {
          setTransitChart(response.data?.data?.chart || null);
        }
      } catch (err: any) {
        if (!cancelled) {
          setTransitChart(null);
          setError(err?.response?.data?.message || 'Failed to load current transit planets.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadTransit();
    return () => { cancelled = true; };
  }, [chartData, enabled, selectedTiming.date, selectedTiming.time, transitTiming.timezoneOffset]);

  return { transitChart, loading, error, transitTiming };
};
